import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  headerCard: {
    width: '100%',
    '& .ant-card-body': {
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  },
  treatmentCard: {
    '& .ant-card-body': {
      padding: 0
    }
  },
  treatmentContent: {
    padding: '24px 24px'
  },
  collapseHeader: {
    '.ant-collapse-item .ant-collapse-header': {
      backgroundColor: `${token.colorWhite} !important`,
      height: 'auto !Important',
      borderRadius: '8px !important'
    },
    '.ant-collapse-item:last-child': {
      borderRadius: '8px !important'
    }
  },
  collapseHeaderMargin: {
    marginBottom: 16,
    border: `1px solid ${token.colorSplit} !important`,
    borderRadius: 8,
    margin: 24
  },
  adverseField: {
    minWidth: 280,
    maxWidth: 280
  },
  tagsWrapper: {
    marginTop: 16
  },
  dropdownRender: {
    padding: 4
  },
  collapseChildren: {
    padding: '16px 24px',
    paddingTop: 0
  },
  tags: {
    borderRadius: 16,
    padding: '4px 10px 4px 12px',
    color: token.primary.primary1,
    backgroundColor: token.blue1,
    border: 'none',
    '.ant-tag-close-icon': {
      color: token.primary.primary1
    }
  }
}))
